import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-desk",
  "use": "icon-leo-desk-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-desk\">\r\n<g transform=\"translate(-61.440 -97.280) scale(1.120000)\">\r\n<path d=\"M128 640h768v128H128V640zm96-320h608v288H224V320zm96 64v160h416V384H320z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-desk.svg
// module id = dGxu
// module chunks = 414